module.exports = __webpack_public_path__ + "img/43.33e13d45.jpg";